
import { RevCarousel } from '@ds/components/Carousel'
import { RevIllustration } from '@ds/components/Illustration'

import { parsedHash } from '@core/helpers'

import { GRADE_TO_COLOR, GRADE_TO_GALLERY } from './ConditionGuidance.constants'
import translations from './ConditionGuidance.translations'

export default {
  components: {
    RevCarousel,
    RevIllustration,
  },
  computed: {
    translations: () => translations,
    gradeId() {
      const { l } = parsedHash(this.$route.hash)

      return parseInt(l, 10)
    },
    images() {
      return GRADE_TO_GALLERY[this.gradeId]
    },
    backgroundColor() {
      return GRADE_TO_COLOR[this.gradeId]
    },
  },
}
